"use strict";
(self["webpackChunkdemi"] = self["webpackChunkdemi"] || []).push([["table"],{

/***/ "./src/js/modules/table.ts":
/*!*********************************!*\
  !*** ./src/js/modules/table.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var simplebar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! simplebar */ "./node_modules/simplebar/dist/index.mjs");
/* harmony import */ var simplebar_dist_simplebar_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! simplebar/dist/simplebar.css */ "./node_modules/simplebar/dist/simplebar.css");
/* harmony import */ var resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! resize-observer-polyfill */ "./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js");
/*!
 *
 *  table.ts
 *
 */



window.ResizeObserver = resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_2__["default"];
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(elems) {
    elems.forEach(function (elem) {
        new simplebar__WEBPACK_IMPORTED_MODULE_0__["default"](elem);
    });
}


/***/ })

}]);